import FormattedMessage from 'I18n/components/FormattedMessage';
import SegmentName from 'personalization-lib/components/targeting/SegmentName';
import { jsx as _jsx } from "react/jsx-runtime";
const TargetingInfo = ({
  segmentIdentifier,
  targetingState
}) => {
  if (!segmentIdentifier) {
    return targetingState ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.targeting.filteredVisitors"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "personalizationLib.targeting.allVisitors"
    });
  }
  return /*#__PURE__*/_jsx(SegmentName, {
    segmentIdentifier: segmentIdentifier
  });
};
export default TargetingInfo;